webpackJsonp([236594062348235],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _MarkdownPage = __webpack_require__(46);
	
	var _MarkdownPage2 = _interopRequireDefault(_MarkdownPage);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createLink = __webpack_require__(35);
	
	var _sectionList = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Docs = function Docs(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  return Glamor.createElement(_MarkdownPage2.default, {
	    createLink: _createLink.createLinkDocs,
	    location: location,
	    markdownRemark: data.markdownRemark,
	    sectionList: _sectionList.sectionListDocs,
	    titlePostfix: ' - React'
	  });
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    */
	
	Docs.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Docs;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-docs-js-b823d8c11e924592ecf5.js